import React, { useEffect, useState } from "react";
import "../ContextMenu.css";

const ContextMenu = ({ menuItems = [], onMenuClick, onClarify }) => {
    const [position, setPosition] = useState(null);

    useEffect(() => {
        const registerRightClick = (e) => {
            e.preventDefault();
            setPosition({ top: e.clientY, left: e.clientX });
        };
        
        const clickAnywhere = () => {
            setPosition(null);
        };
        
        document.addEventListener("contextmenu", registerRightClick);
        document.addEventListener("click", clickAnywhere);
        
        return () => {
            document.removeEventListener("contextmenu", registerRightClick);
            document.removeEventListener("click", clickAnywhere);
        };
    }, []);

    const getSelectedText = () => {
        if (window.getSelection) {
            return window.getSelection().toString();
        } else if (document.selection && document.selection.type !== "Control") {
            return document.selection.createRange().text;
        }
        return '';
    };

    const handleMenuClick = (menuItem) => {
        const selectedText = getSelectedText();
        
        if (menuItem === 'Clarify' && onClarify) {
            onClarify(selectedText);
        } else if (onMenuClick) {
            onMenuClick(menuItem, selectedText);
        }
        
        setPosition(null); // Close the context menu
    };

    if (!position) {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                left: `${position.left}px`,
                top: `${position.top}px`,
                zIndex: 1000,
                backgroundColor: 'white',
                border: '1px solid #d9d9d9',
                borderRadius: 6,
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                padding: '4px 0',
                minWidth: 120
            }}
        >
            {menuItems.map((menuItem, index) => (
                <div
                    key={index}
                    onClick={() => handleMenuClick(menuItem)}
                    style={{
                        padding: '8px 16px',
                        cursor: 'pointer',
                        fontSize: 14,
                        transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#f5f5f5';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                    }}
                >
                    {menuItem}
                </div>
            ))}
        </div>
    );
};

export default ContextMenu;
